module.exports = __webpack_public_path__ + "static/media/codeSara.f70dd59b.jpg";